import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { fetchUserLogin } from '../../utils/api';
import DEFAULT_ROUTES from '../../constants/routes';
import GhostLoader from '../Loaders/ghostloader';
import { useDispatch, useSelector } from 'react-redux';
import { setUser } from '../../features/auth/authSlice';

const withAuthenticatedData = (WrappedComponent) => {
    return (props) => {
        const navigate = useNavigate();
        const location = useLocation();
        const user = useSelector((state) => state.auth.user);
        const dispatch = useDispatch();
        const [loading, setLoading] = useState(false);

        const isPublicRoute = (path) =>
            path === DEFAULT_ROUTES.LOGIN ||
            path === DEFAULT_ROUTES.SIGNUP ||
            path === DEFAULT_ROUTES.TERMS ||
            path === DEFAULT_ROUTES.PRIVACY;

        useEffect(() => {
            const path = location.pathname;
            const publicRoute = isPublicRoute(path);

            if (user) {
                if (publicRoute) {
                    navigate(`${DEFAULT_ROUTES.BASE_URL}${DEFAULT_ROUTES.PROJECT}`);
                }
                return;
            }

            (async () => {
                if (!publicRoute) {
                    setLoading(true);
                }
                const currentUser = await fetchUserLogin();
                if (currentUser?.status === 1 && currentUser?.data?.user) {
                    dispatch(setUser({ user: currentUser.data.user }));
                    setLoading(false);
                    if (publicRoute) {
                        navigate(`${DEFAULT_ROUTES.BASE_URL}${DEFAULT_ROUTES.PROJECT}`);
                    }
                } else if (publicRoute) {
                    setLoading(false);
                } else {
                    setLoading(false);
                    navigate(DEFAULT_ROUTES.LOGIN);
                }
            })();
        }, [navigate, user, location.pathname, dispatch]);

        if (loading) {
            return <GhostLoader />;
        }

        if (!user && !isPublicRoute(location.pathname)) {
            return null;
        }

        return <WrappedComponent {...props} />;
    };
};

export default withAuthenticatedData;